module.exports = __webpack_public_path__ + "static/media/DSC01861.06949de4.jpg";